import { IObject3D } from '../../Interfaces';
import { Rect } from './Rect';
import { Selectable } from '../Selectable';
import { EmptyRect } from './EmptyRect';
declare let THREE: any;

export class Post extends Selectable {
  public scaleCor;

  getBoundingBoxObjects(): Array<any> {
    const objs = this.children.filter(
      ch => ch.name === Rect.Name || ch.name === EmptyRect.Name || ch.name === 'text'
    );
    return objs;
  }

  public scale;
  constructor() {
    super();
    this.scaleCor = 1;
    
  }

  update() {
    const children = this.children.filter(ch => ch instanceof Rect);
    children.forEach(ch => {
      ch.updateTextureRotation(this.getRoot())
      // if (ch.name !== EmptyRect.Name) {
      //   ch.scale.set(this.scaleCor, 1, this.scaleCor);    
      // }
    });
    (<any>this).scale.set(this.scaleCor, 1, this.scaleCor);  
    this.children.forEach(ch => {
      if (ch.name === EmptyRect.Name || ch.name === Rect.name) {
        ch.scale.set(1 / this.scaleCor, 1, 1 / this.scaleCor);    
      }
    })
  }

  getRoot(): IObject3D {
    return this;
  }

  getSize(): number {
    return 10;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/Post.ts